// extracted by mini-css-extract-plugin
export default {"heading":"CC-z","corrected":"DC-z","redirectVerbiageContainer":"EC-z","redirectVerbiageText":"FC-z"};